module.exports = __webpack_public_path__ + "img/BG_Clasificacion.221aceb2.png";